/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiDraftReferenceType } from './InternalApiDraftReferenceType';
import {
    InternalApiDraftReferenceTypeFromJSON,
    InternalApiDraftReferenceTypeFromJSONTyped,
    InternalApiDraftReferenceTypeToJSON,
    InternalApiDraftReferenceTypeToJSONTyped,
} from './InternalApiDraftReferenceType';

/**
 * A draft note for a reference (alert, person, etc.)
 * @export
 * @interface InternalApiNoteDraft
 */
export interface InternalApiNoteDraft {
    /**
     * 
     * @type {number}
     * @memberof InternalApiNoteDraft
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiNoteDraft
     */
    content: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiNoteDraft
     */
    referenceId: number;
    /**
     * 
     * @type {InternalApiDraftReferenceType}
     * @memberof InternalApiNoteDraft
     */
    referenceType: InternalApiDraftReferenceType;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiNoteDraft
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiNoteDraft
     */
    updatedTime: Date;
}



/**
 * Check if a given object implements the InternalApiNoteDraft interface.
 */
export function instanceOfInternalApiNoteDraft(value: object): value is InternalApiNoteDraft {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('referenceId' in value) || value['referenceId'] === undefined) return false;
    if (!('referenceType' in value) || value['referenceType'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('updatedTime' in value) || value['updatedTime'] === undefined) return false;
    return true;
}

export function InternalApiNoteDraftFromJSON(json: any): InternalApiNoteDraft {
    return InternalApiNoteDraftFromJSONTyped(json, false);
}

export function InternalApiNoteDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiNoteDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content': json['content'],
        'referenceId': json['referenceId'],
        'referenceType': InternalApiDraftReferenceTypeFromJSON(json['referenceType']),
        'createdTime': (new Date(json['createdTime'])),
        'updatedTime': (new Date(json['updatedTime'])),
    };
}

export function InternalApiNoteDraftToJSON(json: any): InternalApiNoteDraft {
    return InternalApiNoteDraftToJSONTyped(json, false);
}

export function InternalApiNoteDraftToJSONTyped(value?: InternalApiNoteDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'content': value['content'],
        'referenceId': value['referenceId'],
        'referenceType': InternalApiDraftReferenceTypeToJSON(value['referenceType']),
        'createdTime': value['createdTime'].toISOString(),
        'updatedTime': value['updatedTime'].toISOString(),
    };
}

